<template>
  <div>
    <loading
      :active="isLoading"
      :is-full-page="true"
    />
    <div
      ref="content"
      class="container-dad"
    >
      <div v-if="coldChain.length > 0">
        <div
          uk-grid
          class="div-title"
        >
          <div class="uk-flex icon-div">
            <font-awesome-icon
              class="icon-back"
              icon="arrow-left"
              @click="pushPage('DragAndDropTimeLine')"
            />
          </div>
          <div class="uk-width-expand uk-flex uk-flex-center">
            <h5
              class="title uk-text-center uk-display-inline-block"
            >
              REPORTE DE CONSULTA CADENA DE FRÍO
            </h5>
          </div>
        </div>
        <div
          class="uk-flex uk-flex-right"
          style="margin: 10px 0px"
        >
          <label
            class="uk-text-right download-link"
            @click="downloadPdf"
          >
            <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'download' }" />&nbsp;
            <span>Descargar Reporte de Cadena de Frío</span>
          </label>
        </div>

        <data-report-cold-chain />

        <fruit-clasificated />
        <div class="uk-margin-top">
          <h5 class="sub-title">
            Cadena de Frío Exportación
          </h5>
          <div
            class="uk-flex uk-flex-wrap uk-flex-around"
            style="margin: 30px 0px"
          >
            <cold-chain-direction class="sub-main" />
            <cold-chain-process-graphics
              class="gif"
              @setImage="plotlyImage = $event"
            />
          </div>
        </div>
      </div>
      <complete-process />
      <div>
        <h5 class="sub-title uk-margin-top uk-text-center">
          Información adicional
        </h5>
      </div>
      <div
        style="margin: 30px 0px"
        class="uk-flex uk-flex-around link-cold-chain"
      >
        <a
          class="uk-text-right download-link"
          @click="perishablesManual"
        >
          <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'download' }" />&nbsp;
          <span>Para información más detallada click para descargar <span>El Manual de Perecederos</span></span>
        </a>
        <hr>
        <a
          class="uk-text-right download-link"
          @click="pushPage('SlideShow')"
        >
          <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'download' }" />&nbsp;
          <span>Ver Informativo de Cadena de Frío</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import DataReportColdChain from '../components/ColdChainComponents/DataReportColdChain.vue'
import FruitClasificated from '../components/ColdChainComponents/FruitsClassified.vue'
import CompleteProcess from '../components/ColdChainComponents/CompleteProcess.vue'
import ColdChainDirection from '../components/ColdChainComponents/ColdChainDirection.vue'
import ColdChainProcessGraphics from '../components/ColdChainComponents/ColdChainProcessGraphics.vue'
import { mapGetters } from 'vuex'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
export default {
  components: {
    DataReportColdChain,
    FruitClasificated,
    CompleteProcess,
    ColdChainDirection,
    ColdChainProcessGraphics
  },
  data () {
    return {
      plotlyImage: null,
      item: null,
      isLoading: false,
      elementValue: {}
    }
  },
  computed: {
    ...mapGetters([
      'coldChain',
      'productStore',
      'storeChainType'
    ])
  },
  beforeMount () {
    if (this.coldChain.length === 0) {
      this.$router.push('/cadena-de-frio')
    }
  },
  methods: {
    pushPage (name) {
      this.$router.push({ name })
      this.$windowPlugin.scrollToTop()
    },
    downloadPdf () {
      const imgData = this.plotlyImage
      const doc = new jsPDF() //eslint-disable-line
      let chainType = null
      if (this.storeChainType === 1) {
        chainType = 'Consumo Local'
      } else if (this.storeChainType === 2) {
        chainType = 'Exportación Agricola'
      } else if (this.storeChainType === 3) {
        chainType = 'Importación'
      }

      doc.addImage('../../../assets/img/only-logo.jpg', 'JPEG', 83, 2, 33, 14)

      doc.addImage('../../../assets/img/logo-cost.png', 'png', 5, 1, 29, 18)
      doc.addImage('../../../assets/img/header-logo-observatory-national.jpg', 'JPEG', 164, 1, 40, 17)
      doc.line(6, 19, 204, 19)

      doc.setFontSize(14)
      doc.setTextColor(100)
      doc.setFont('helvetica', 'bold')
      doc.text('Reporte Cadena de Frío', 75, 28)
      doc.setFontSize(10)
      doc.setDrawColor(0)
      doc.setFillColor(63, 128, 187)
      doc.rect(14, 35, 55, 40, 'F')
      doc.setTextColor(255, 255, 255)
      doc.text(15, 42, 'Empresa:')
      doc.text(15, 52, 'Cadena de Frío Consultada:')
      doc.text(15, 62, 'Producto:')
      doc.text(15, 72, 'No. de Procesos')
      doc.setTextColor(100, 100, 100)
      doc.setDrawColor(0)
      doc.setFillColor(245, 245, 245)
      doc.rect(69, 35, 127, 40, 'F')
      doc.text(71, 42, this.productStore.companyName)
      doc.text(71, 52, this.productStore.currentChainDescription)
      doc.text(71, 62, this.productStore.selectedProducts.map(x => x.label.trim()).join(', '))
      doc.text(71, 72, this.coldChain.length.toString())

      doc.setFontSize(14)
      doc.setTextColor(46, 116, 181)

      doc.autoTable({ html: '#fruitclassified', startY: 80 })
      doc.autoTable({ html: '#fruitclassified1' })

      doc.autoTable({ html: '#coldChainDirection' })
      doc.addPage()
      doc.addImage(imgData, 'JPEG', 15, 40, 150, 150)
      doc.addPage()

      let a = 30
      let c1 = 83
      let c2 = 60
      let y = 20
      let yText = 54
      let line = 35
      doc.setFontSize(16)
      doc.setTextColor(100)
      doc.text(57, 14, 'Cadena de Frío  de')
      doc.text(113, 14, chainType)
      doc.setTextColor(46, 116, 181)

      let yTriangle1 = 83
      let yTriangle2 = 80
      let xTriangle1 = 35
      let xTriangle2 = 37
      let xTriangle3 = 33

      for (let i = 0; i < this.coldChain.length; i++) {
        const element = this.coldChain[i]
        doc.addImage(element.image, 'PNG', a, y, 30, 30)
        doc.setDrawColor(255, 0, 0)
        if (i < this.coldChain.length - 1) {
          doc.setLineWidth(0.5)
          doc.setFillColor(255, 0, 0)
          doc.triangle(yTriangle1, xTriangle1, yTriangle2, xTriangle2, yTriangle2, xTriangle3, 'FD')
          doc.line(c1, line, c2, line)
        }
        doc.setFont('Arial', 'B', 5)
        doc.setFontSize(8)
        this.convertToPascalCase(element.description)
        doc.text(element.tooltiptext ?? this.elementValue, a, yText)
        a = a + 55
        c1 = c1 + 55
        c2 = c2 + 55
        yTriangle1 = yTriangle1 + 55
        yTriangle2 = yTriangle2 + 55

        if (i > 0 && (i + 1) % 3 === 0) {
          y = y + 45
          yText = yText + 45
          line = line + 45
          xTriangle1 = xTriangle1 + 45
          xTriangle2 = xTriangle2 + 45
          xTriangle3 = xTriangle3 + 45
          a = 30
          c1 = 83
          c2 = 60
          yTriangle1 = 83
          yTriangle2 = 80
        }
      }
      doc.save('Idb.pdf')
    },
    async perishablesManual () {
      this.isLoading = true
      try {
        await this.$services.fileService.downloadFile('/ColdChain/download/perishables-manual')
      } catch (e) {
        console.log(e)
      }
      this.isLoading = false
    },

    convertToPascalCase (element) {
      this.elementValue = element.replace(/\w+/g,
        function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase() })
      return this.elementValue
    }
  }
}
</script>

<style scoped>
*{
  font-size: 13px;
}
.container-dad{
  margin: 30px 0px;
}
.title-tooltip{
  font-weight: 600 ;
}
.sub-main{
  align-items: center;
  justify-content: center;
  width: 35%;
  min-width: 300px;
  margin: 0px 10px;
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;

}
.title{
  background: #002c3f;
  color: #fff;
  padding: 10px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px !important;
  margin-right: 13%;
  font-weight: normal;

}
.sub-title{
   background: #002c3f;
  color: #fff;
  padding: 10px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px !important;
}
.gif {
  text-align: center;
  width: 40%;
  min-width: 300px;
}
.icon-back {
  color: #fff;
  width: 100%;
  margin: auto 10px;
  font-size: 20px;
  cursor: pointer;
  min-width: 13px
}
.icon-back:hover {
  font-size: 30px;
  color: rgb(40, 170, 22) !important;
  box-shadow: 0 7px 16px rgb(111, 120, 124);
  transition: all 0.2s ease;
}
.div-title{
  background: #002c3f;
}
.icon-div{
  width: 10%;
  position: relative;
}
.download-link {
  cursor: pointer;
  margin: 1px 10px;
  color: #0177aa;
  text-align: center !important;
}
.link-cold-chain{
  display: flex;
  flex-wrap: wrap;
}
@media screen and (max-width: 940px ) {
.sub-title{
  font-size: 10px !important;
}
.title{
  font-size: 10px !important;
}
.sub-main{
  margin: 0px 5px
}

}
@media screen and (max-width: 860px){
  .link-cold-chain{
    flex-direction: column-reverse
  }
  .download-link{
    text-decoration: underline;
    font-size: 10px;
  }
  hr{
    margin: 10px
  }
}

</style>
